$(function($){
    /******************* JOE MENU MODS ************************/
  $('.artist-list-ul li:nth-of-type(15)').after('<div class="more-but"><a>VIEW ALL</a></div>');
  
  function screenClass() {
  if ($(window).width() < 768) {
  //alert('Less than 768');
  $('body').on('click','.more-but', function(e) { 
  //alert("The button was clicked.");
  $('.artist-list-wrapper').css("max-height", "none");
  $('.more-but').hide();
  });
  }
};
// Fire.
screenClass();

// And recheck when window gets resized.
$(window).bind('resize',function(){
    screenClass();
});
  /******************* HOME BANNER SLIDER ************************/
  $('.main-banner').slick({
    dots: true,
    arrows: false,
    adaptiveHeight: true,
    autoplay: true,
    speed: 1200
  });
  /******************* HOME BANNER SLIDER ************************/

  $('.blog-slider-wrap').slick({
    autoplay: false,
    dots: true,
    arrows: true,
    centerMode: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  /******************* PRODUCT PAGE SLIDER ************************/
  $('.shop-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    fade: true,
    adaptiveHeight: true,
    asNavFor: '.shop-slider-nav',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true
        }
      }
    ]
  });

  $('.shop-slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.shop-slider',
    dots: false,
    arrows: true,
    centerMode: false,
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical: false
        }
      }, 
      {
        breakpoint: 371,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          vertical: false
        }
      }
    ]
  });

  /******************* PRODUCT PAGE SLIDER ************************/

  var get_v_img = '';
  $('.template-product').on('change', '.main-v-dd', function(e) {
    get_v_img = $(this).find('option:selected').data('vimg');
    $(".shop-slider .slick-slide").each(function () {
      var current_slide_img = $(this).find('img').data('custom-img-id');
      if (get_v_img == current_slide_img) {
        var get_current_slide_no = $(this).data('slick-index');
        $('.shop-slider').slick('slickGoTo', get_current_slide_no);
      }
    });

    $(".shop-slider-nav .slick-slide").each(function () {
      var current_slide_img = $(this).find('.product-single__thumbnail').data('custom-img-id');
      if (get_v_img == current_slide_img) {
        var get_current_slide_no = $(this).data('slick-index');
        $('.shop-slider-nav').slick('slickGoTo', get_current_slide_no);
      }
    });
  });
  
  /******************* FEATURED PRODUCTS ************************/
  $('.feat-products-slider-wrap').slick({
    lazyLoad: 'ondemand',
    autoplay: false,
    dots: true,
    arrows: true,
    centerMode: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 421,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  /******************* FEATURED PRODUCTS ************************/

});